import ApprovalPage from './ApprovalPage';

const ApprovePage = () => {
  return <ApprovalPage />;
};

export default ApprovePage;
